import React, { useEffect } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Alert,
} from "reactstrap"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import {
    setBreadcrumbItems,
} from "../../store/actions"

const InvoiceCreate = props => {
    document.title = "Créer Facture | CRM Entreprise"

    const breadcrumbItems = [
        { title: "Finances", link: "#" },
        { title: "Factures", link: "/finance/invoices" },
        { title: "Créer", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Nouvelle Facture", breadcrumbItems)
    }, [])

    return (
        <React.Fragment>
            <div className="container-fluid">
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <CardTitle className="h4 mb-4">Créer une nouvelle facture</CardTitle>

                                <Alert color="info" className="mb-4">
                                    <i className="mdi mdi-information-outline me-2"></i>
                                    Le formulaire de création de facture sera disponible prochainement.
                                    Pour l'instant, vous pouvez consulter les factures existantes.
                                </Alert>

                                <div className="text-center py-5">
                                    <i className="mdi mdi-file-document-outline" style={{ fontSize: '64px', color: '#ccc' }}></i>
                                    <h5 className="mt-3 mb-4">Formulaire de facture</h5>
                                    <p className="text-muted mb-4">
                                        Le formulaire complet de création de facture avec sélection de client,<br />
                                        ajout de lignes d'articles, calcul automatique de TVA et remises sera disponible très bientôt.
                                    </p>
                                    <Link to="/finance/invoices">
                                        <button className="btn btn-primary">
                                            <i className="mdi mdi-arrow-left me-1"></i> Retour aux factures
                                        </button>
                                    </Link>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = state => ({})

export default connect(mapStateToProps, {
    setBreadcrumbItems,
})(InvoiceCreate)
